import type { UUID } from '@cobliteam/common-types';

export enum SettingsType {
  ROAD_SPEED_LIMIT = 'ROAD_SPEED_LIMIT',
  VEHICLE_SPEED_LIMIT = 'VEHICLE_SPEED_LIMIT',
  STOP_IDLE_TIME = 'STOP_IDLE_TIME',
}

export interface UserAlertsFilters {
  wantedAlertTypes?: SettingsType[];
  wantedGroups?: UUID[];
  wantedVehicleIds?: UUID[];
}
